import { consts } from './js/consts'
require('./index.css')

export default class BrandSubNavigation {
  constructor () {
    this.menuBarSelector = document.querySelector(`.${consts.BRAND_NAVIGATION_TOP_MENU_BAR}`)
    this.breadcrumbSelector = document.querySelector(`.${consts.BRAND_SUB_NAVIGATION_BREADCRUMB}`)
    this.dropdownSelectors = document.querySelectorAll(`.${consts.BRAND_NAVIGATION_TOP_MENU_LINK}`)
    this.subNavDOMelems = document.querySelectorAll(`.${consts.BRAND_SUB_NAV}`)
    this.subNavTagClass = this.breadcrumbSelector.getAttribute(consts.BRAND_SUB_NAV_TAG_CLASS)
    this.subNavTags = document.querySelectorAll(`.${this.subNavTagClass}`)
    this.navBarVisibilityBtn = null
    if (this.subNavDOMelems.length > 0 && this.subNavTags.length > 0) {
      this.loadSubNavBars()
    } else {
      for (let i = 0; i < this.subNavDOMelems.length; i++) {
        this.subNavDOMelems[i].remove()
      }
    }
  }

  loadSubNavBars () {
    for (let i = 0; i < this.subNavDOMelems.length; i++) {
      const brandSubNavContentDOMelem = this.subNavDOMelems[i].querySelector(`.${consts.BRAND_SUB_NAV_CONTENT}`)
      const childNodesLength = brandSubNavContentDOMelem.childNodes.length - 1
      let replaceElem = brandSubNavContentDOMelem.childNodes[childNodesLength]
      brandSubNavContentDOMelem.replaceChild(this.generateDropdownTriggerDOMelem(replaceElem.textContent), replaceElem)
      this.subNavDOMelems[i].appendChild(this.generateSubNavDropdownDOMelem())
    }
    this.injectVisibiltyBtn()
    this.toggleAnimations()
    this.toggleBarVisibilityChange()
    this.activeSubNavTag = document.querySelector(`[href='#${this.subNavTagClass}0']`)
  }

  generateDropdownTriggerDOMelem (label) {
    let elem = document.createElement('div')
    elem.className = consts.BRAND_SUB_NAV_CONTENT_TRIGGER
    elem.onclick = this.toggleSubNavDropdown
    elem.innerHTML = `${label}`
    return elem
  }

  generateSubNavDropdownDOMelem () {
    let subNavDropdown = document.createElement('ul')
    window.addEventListener('load', () => {
      let dropdownTriggerRect = document.querySelector(`.${consts.BRAND_SUB_NAV_CONTENT_TRIGGER}`).getBoundingClientRect()
      subNavDropdown.style.paddingLeft = `${dropdownTriggerRect.left}px`
    })
    subNavDropdown.className = consts.BRAND_SUB_NAV_DROPDOWN
    subNavDropdown.innerHTML = `<a class='${consts.BRAND_SUB_NAV_NAVTAG}'>Top</a>`
    let documentTags = document.querySelectorAll(`.${this.subNavTagClass}`)
    for (let i = 0; i < documentTags.length; i++) {
      documentTags[i].id = `${this.subNavTagClass}${i}`
      subNavDropdown.innerHTML += `<li><a class='${consts.BRAND_SUB_NAV_NAVTAG}' href='#${this.subNavTagClass}${i}'>${documentTags[i].textContent}</a></li>`
    }
    return subNavDropdown
  }

  injectVisibiltyBtn () {
    let statusContainer = document.querySelector(`.${consts.BRAND_HEADER_STATUS_CONTAINER}`)
    if (statusContainer) {
      this.navBarVisibilityBtn = document.createElement('a')
      this.navBarVisibilityBtn.className = `${consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN} ${consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE}`
      this.navBarVisibilityBtn.addEventListener('click', () => {
        if (this.isOpenDropdown()) return
        this.navBarVisibilityBtn.classList.contains(consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE) ? this.hideNavBar() : this.showNavBar()
      })
      statusContainer.appendChild(this.navBarVisibilityBtn)
    } else {
      console.error('Brand Navigation error. Failed to inject visibility button. Unable to find status container')
    }
  }

  toggleSubNavDropdown () {
    let tagsBar = document.querySelector(`.${consts.BRAND_SUB_NAV_DROPDOWN}`)
    tagsBar.classList.toggle(consts.BRAND_SUB_NAV_DROPDOWN_VISIBLE)
  }

  toggleAnimations () {
    let inPageTags = document.querySelectorAll(`.${consts.BRAND_SUB_NAV_NAVTAG}`)
    let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style
    const animFunction = (isSmoothScrollSupported) ? this.scrollToElement : this.scrollToElementManual
    for (let i = 0; i < inPageTags.length; i++) {
      const targetTag = inPageTags[i].getAttribute('href')
      inPageTags[i].addEventListener('click', (el) => {
        el.preventDefault()
        i === 0 ? this.scrollToTop(200) : animFunction(targetTag)
      })
    }
  }

  toggleBarVisibilityChange () {
    window.addEventListener('scroll', () => {
      const screenTopOffset = window.pageYOffset
      const screenBottomOffset = window.pageYOffset + window.innerHeight
      for (let i = 0; i < this.subNavTags.length; i++) {
        if (this.subNavTags[i].offsetTop > screenTopOffset && this.subNavTags[i].offsetTop < screenBottomOffset) {
          this.activeSubNavTag.classList.remove(consts.BRAND_SUB_NAV_NAVTAG_ACTIVE)
          this.activeSubNavTag = document.querySelector(`[href='#${this.subNavTagClass}${i}']`)
          this.activeSubNavTag.classList.add(consts.BRAND_SUB_NAV_NAVTAG_ACTIVE)
        }
      }
      const offsetDelta = screenTopOffset - this.previousScrollVal
      if (!this.isOpenDropdown() && offsetDelta !== 0) {
        offsetDelta > 0 ? this.hideNavBar() : this.showNavBar()
      }
      this.previousScrollVal = screenTopOffset
    }, {
      capture: true,
      passive: true
    })
  }

  scrollToElementManual (id) {
    let to = document.querySelector(id).offsetTop - window.innerHeight / 2 + 60
    let element = document.body
    let isIE = false || !!document.documentMode
    let duration = 300
    if (isIE) {
      element = document.documentElement
    }

    if (duration <= 0) return
    let from = element.scrollTop
    let difference = to - from
    let perTick = difference / duration * 10

    setTimeout(() => {
      element.scrollTop = to
    }, duration)
    duration = duration - 10

    while (duration > 0) {
      setTimeout(() => {
        element.scrollTop += perTick
      }, duration)
      duration = duration - 10
    }
  }

  scrollToElement (targetElement) {
    document.querySelector(targetElement).scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
  }

  scrollToTop (scrollDuration) {
    const intervalStep = 15
    const scrollStep = -window.pageYOffset / (scrollDuration / intervalStep)
    const scrollInterval = setInterval(() => {
      window.pageYOffset !== 0 ? window.scrollBy(0, scrollStep) : clearInterval(scrollInterval)
    }, intervalStep)
  }

  hideNavBar () {
    if (this.menuBarSelector.classList.contains(consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)) return
    this.menuBarSelector.classList.add(consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)
    this.breadcrumbSelector.classList.add(consts.BRAND_SUB_NAV_ANIM_UP)
    this.navBarVisibilityBtn.classList.remove(consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE)
  }

  showNavBar () {
    if (!this.menuBarSelector.classList.contains(consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)) return
    this.menuBarSelector.classList.remove(consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)
    this.breadcrumbSelector.classList.remove(consts.BRAND_SUB_NAV_ANIM_UP)
    this.navBarVisibilityBtn.classList.add(consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE)
  }

  isOpenDropdown () {
    for (let i = 0; i < this.dropdownSelectors.length; i++) {
      if (this.dropdownSelectors[i].classList.contains('is-visible')) {
        return true
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/sub-navigation/index.js